import { render, staticRenderFns } from "./commen-box.vue?vue&type=template&id=09419a9e&scoped=true&"
import script from "./commen-box.vue?vue&type=script&lang=js&"
export * from "./commen-box.vue?vue&type=script&lang=js&"
import style0 from "./commen-box.vue?vue&type=style&index=0&id=09419a9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09419a9e",
  null
  
)

export default component.exports